import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../../language/vn';
import {ThuTempService} from '../../../../service/email/service-thutemp';
import {ThuService} from '../../../../service/email/service-thu';
import {DocumentDraftService} from '../../../../service/draft/service-documentdraft';
import {Sessioncommand} from '../../../../global/sessioncommand';

@Component({
  selector: 'egov-tonghop-email',
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EmailTongHopComponent implements OnInit, AfterViewInit {

  public totalThuGui: number =0;
  public totalThuNhan: number =0;
  public totalThuXoa: number =0;
  public totalThuSoan: number =0;
  public emailStatus: string = '1';
  public nguoiTao: number = Sessioncommand.staffId;
  public ty: string = '';
  public language = language;
  constructor(
    public thuTempService: ThuTempService,
    public thuService: ThuService,
    public documentDraftService: DocumentDraftService
  ) {
  }
  ngAfterViewInit() {
    this.loadTotal();
  }
  ngOnInit(): void {

  }
  public loadTotal()
  {
    this.thuTempService.getCountByKeyword('', this.nguoiTao, -1, 0 ).subscribe(recordCount => this.totalThuGui = recordCount);
    this.thuService.getCountByKeyword('', this.nguoiTao, -1, 0 , this.emailStatus).subscribe(recordCount => this.totalThuNhan = recordCount);
    this.thuService.getCountByKeyword('', this.nguoiTao, -1, 1 , this.emailStatus).subscribe(recordCount => this.totalThuXoa = recordCount);
    this.documentDraftService.getCountByKeyword('','EMAIL', this.nguoiTao ).subscribe(recordCount => this.totalThuSoan = recordCount);
  }

}

